import PortalFormController from "./portal_form_base"

export default class extends PortalFormController {
  isRegisterSuccess(data) {
    return data.ok && data.status === 'verify_email'
  }
}
